import { createContext } from "react";
const ContactUsMultipageContext = createContext({});
export default ContactUsMultipageContext;
